/* =========================================================
   NOMI — theme behaviour
   Vanilla, no dependencies. Progressive enhancement only:
   every interaction here has a working no-JS fallback.
   ========================================================= */
(function () {
  'use strict';

  var cfg = window.NOMI || {};
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- Scrim ---------- */
  var scrim = $('[data-scrim]');
  var openPanel = null;

  function showScrim() {
    if (!scrim) return;
    scrim.hidden = false;
    requestAnimationFrame(function () { scrim.classList.add('is-open'); });
  }

  function hideScrim() {
    if (!scrim) return;
    scrim.classList.remove('is-open');
    setTimeout(function () { scrim.hidden = true; }, 420);
  }

  function openOverlay(el) {
    if (!el) return;
    closeOverlay();
    openPanel = el;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    showScrim();
    var focusable = el.querySelector('button, a, input, textarea, select');
    if (focusable) focusable.focus();
  }

  function closeOverlay() {
    if (!openPanel) return;
    openPanel.classList.remove('is-open');
    openPanel.setAttribute('aria-hidden', 'true');
    openPanel = null;
    document.body.style.overflow = '';
    hideScrim();
  }

  if (scrim) scrim.addEventListener('click', closeOverlay);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeOverlay();
  });

  /* ---------- Menu drawer ---------- */
  var menuDrawer = $('[data-menu-drawer]');

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) {
      e.preventDefault();
      openOverlay(menuDrawer);
    }
    if (e.target.closest('[data-menu-close]')) {
      e.preventDefault();
      closeOverlay();
    }
  });

  /* ---------- Cart ---------- */
  var cartDrawer = $('[data-cart-drawer]');

  function formatMoney(cents) {
    // Shopify money_format is HTML with a placeholder; fall back to a plain rupee string.
    var amount = (cents / 100).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    var fmt = cfg.moneyFormat || '₹{{amount}}';
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, amount);
  }

  function setCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function refreshCartDrawer() {
    if (!cartDrawer) return Promise.resolve();
    return fetch(cfg.routes.cart + '?section_id=', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function () { return fetch(cfg.routes.cart + '.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCartCount(cart.item_count);
        return renderDrawer(cart);
      });
  }

  function renderDrawer(cart) {
    var body = $('[data-cart-body]', cartDrawer);
    if (!body) return;

    if (!cart.item_count) {
      body.innerHTML =
        '<div class="text-center stack" style="padding-block:4rem">' +
        '<span class="sparkle" style="width:1.6rem;height:1.6rem;color:var(--gold)"></span>' +
        '<p class="eyebrow">Your bag is empty</p>' +
        '<a class="btn btn--ghost" href="/collections/all">Continue shopping</a>' +
        '</div>';
      return;
    }

    var items = cart.items.map(function (item, i) {
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') + '" alt="" width="160" height="200" loading="lazy">'
        : '<span class="placeholder-media" style="aspect-ratio:4/5"></span>';

      return (
        '<li class="line-item">' +
        '<a href="' + item.url + '">' + img + '</a>' +
        '<div class="stack flow-sm">' +
        '<a class="line-item__title" href="' + item.url + '">' + item.product_title + '</a>' +
        '<p class="card__price">' + formatMoney(item.final_line_price) + '</p>' +
        '<div style="display:flex;align-items:center;gap:1rem;flex-wrap:wrap">' +
        '<div class="qty">' +
        '<button type="button" data-qty-down aria-label="Decrease quantity">&minus;</button>' +
        '<input type="number" value="' + item.quantity + '" min="0" data-qty-input data-line="' + (i + 1) + '" aria-label="Quantity">' +
        '<button type="button" data-qty-up aria-label="Increase quantity">+</button>' +
        '</div>' +
        '<button type="button" class="link-u" data-line-remove data-line="' + (i + 1) + '">Remove</button>' +
        '</div></div></li>'
      );
    });

    body.innerHTML =
      '<ul role="list">' + items.join('') + '</ul>' +
      '<div class="cart-drawer__foot" style="padding-inline:0">' +
      '<div class="cart-total" style="padding-top:1.25rem">' +
      '<span class="eyebrow">Subtotal</span>' +
      '<span class="pdp__price">' + formatMoney(cart.total_price) + '</span>' +
      '</div>' +
      '<p class="card__meta" style="text-transform:none;letter-spacing:0.06em;margin-bottom:1rem">Taxes and shipping calculated at checkout.</p>' +
      '<form action="' + cfg.routes.cart + '" method="post">' +
      '<button type="submit" name="checkout" class="btn btn--block">Checkout</button>' +
      '</form></div>';
  }

  function changeLine(line, quantity) {
    return fetch(cfg.routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCartCount(cart.item_count);
        renderDrawer(cart);
        return cart;
      });
  }

  /* Open the drawer instead of navigating to /cart */
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-cart-open]');
    if (openBtn && cfg.cartType === 'drawer' && cartDrawer) {
      e.preventDefault();
      openOverlay(cartDrawer);
      return;
    }
    if (e.target.closest('[data-cart-close]')) {
      e.preventDefault();
      closeOverlay();
    }

    var removeBtn = e.target.closest('[data-line-remove]');
    if (removeBtn) {
      e.preventDefault();
      changeLine(parseInt(removeBtn.dataset.line, 10), 0);
    }
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var up = e.target.closest('[data-qty-up]');
    var down = e.target.closest('[data-qty-down]');
    if (!up && !down) return;

    var wrap = (up || down).closest('.qty');
    var input = $('[data-qty-input]', wrap);
    if (!input) return;

    var min = parseInt(input.getAttribute('min') || '0', 10);
    var next = (parseInt(input.value, 10) || 0) + (up ? 1 : -1);
    if (next < min) next = min;
    input.value = next;

    if (input.dataset.line) {
      changeLine(parseInt(input.dataset.line, 10), next);
    } else {
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (input && input.dataset.line) {
      changeLine(parseInt(input.dataset.line, 10), parseInt(input.value, 10) || 0);
    }
  });

  /* ---------- Add to cart ---------- */
  $$('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (cfg.cartType !== 'drawer' || !cartDrawer) return; // let the browser post normally
      e.preventDefault();

      var button = $('[data-add-button]', form);
      var status = $('[data-form-status]', form);
      var label = button ? button.textContent : '';

      if (button) {
        button.setAttribute('aria-disabled', 'true');
        button.textContent = '…';
      }

      fetch(cfg.routes.cart_add, {
        method: 'POST',
        headers: { Accept: 'application/javascript' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw new Error(res.description || res.message);
          if (status) status.textContent = '';
          return refreshCartDrawer();
        })
        .then(function () {
          openOverlay(cartDrawer);
        })
        .catch(function (err) {
          if (status) status.textContent = err.message;
        })
        .finally(function () {
          if (button) {
            button.removeAttribute('aria-disabled');
            button.textContent = label;
          }
        });
    });
  });

  /* ---------- Variant selection ---------- */
  $$('[data-variant-json]').forEach(function (node) {
    var variants;
    try { variants = JSON.parse(node.textContent); } catch (err) { return; }

    var form = node.closest('form');
    if (!form) return;

    var selects = $$('[data-option-index]', form);
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = $('.pdp__price');
    var button = $('[data-add-button]', form);

    function update() {
      var chosen = selects.map(function (s) { return s.value; });
      var match = variants.find(function (v) {
        return chosen.every(function (val, i) { return v.options[i] === val; });
      });

      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.innerHTML = '<span class="price">' + formatMoney(match.price) + '</span>';
      if (button) {
        button.disabled = !match.available;
        button.textContent = match.available ? cfg.strings.addToCart : cfg.strings.soldOut;
      }

      var url = new URL(window.location);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);
    }

    selects.forEach(function (s) { s.addEventListener('change', update); });
  });

  /* ---------- Collection sort ---------- */
  var sortSelect = $('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Product recommendations (async) ---------- */
  var recs = $('[data-recommendations]');
  if (recs && recs.dataset.url) {
    fetch(recs.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var section = doc.querySelector('.section');
        if (section) recs.replaceWith(section);
        observeReveals();
      })
      .catch(function () { /* recommendations are optional */ });
  }

  /* ---------- Reveal on scroll ---------- */
  var observer;

  function observeReveals() {
    if (!('IntersectionObserver' in window)) {
      $$('.reveal').forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-in');
              observer.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -8% 0px' }
      );
    }
    $$('.reveal:not(.is-in)').forEach(function (el) { observer.observe(el); });
  }

  observeReveals();
})();
